import {formatStreetAddress} from '@brunata-angular/util';
import {CustomizedExportSystem} from './systems.service';
import {SystemRow} from './systems-table.component';

export function relevantSystemRows(
    systems: CustomizedExportSystem[] | null | undefined,
    selectedSuperTypes: ReadonlyArray<string>,
): SystemRow[] | null | undefined {
    if (systems == null) {
        return systems;
    }
    return systems
        .filter(system =>
            system.meterSuperTypeNos.some(superType => selectedSuperTypes.includes(superType)),
        )
        .map(system => ({
            systemNo: system.systemNo,
            buildingName: system.buildingName,
            address: formatStreetAddress(system),
        }));
}
